import { getDefaultTheme } from '@concur/ui-theming';
import { SAP_THEMES_BRANDING_ID } from '../constants';

export default (brandingId, themeName) => {
    if (brandingId === SAP_THEMES_BRANDING_ID) {
        return true;
    }

    const theme = themeName || getDefaultTheme(brandingId);

    return theme.indexOf('sap_') >= 0;
};
